export default "__VITE_ASSET__Kohz0q6V__"